import { Pipe } from '@angular/core';
import { MasterModel } from 'shared';
import { UUID } from 'symbols';

@Pipe({
  name: 'findMasterPipe',
  standalone: true
})
export class FindMasterPipe {
  transform(masterId: UUID, masters: MasterModel[]): MasterModel {
    return masters.find(m => m.id === masterId);
  }
}
